import React from 'react';

const BottomButtons = ({ leftButton, rightButton }) => {
    return (
        <div className="row my-2 my-md-4">
            <div className="col-12 col-md mr-md-1 order-last order-md-first">
                <button
                    type="button"
                    className={`btn btn-md w-100 ${leftButton.className}`}
                    disabled={leftButton.disabled}
                    onClick={leftButton.action}>
                    {leftButton.text}
                </button>
            </div>
            <div className="col-12 col-md ml-md-2 order-first order-md-last mb-2 mb-md-0">
                <button
                    type="button"
                    className={`btn btn-md w-100 ${rightButton.className}`}
                    disabled={rightButton.disabled}
                    onClick={rightButton.action}>
                    {rightButton.text}
                </button>
            </div>
        </div>
    );
};

export default BottomButtons;
